import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useNavigate } from "react-router-dom";
import Cookies from "js-cookie";
import API from "../../../api/API";
import { callFunctionIfExists } from "../../../../utils/GeneralUtils";

const useDeleteSession = () => {
  const navigate = useNavigate();
  const queryClient = useQueryClient();

  const deleteSession = useMutation({
    mutationFn: (sessionID?: string) => {
      const currentSessionID = Cookies.get("session");
      let onSuccess: null | (() => void) = null;

      if (currentSessionID === sessionID) {
        onSuccess = () => {
          navigate("/login");
          Object.keys(Cookies.get()).forEach(function (cookieName) {
            const neededAttributes: any = { sameSite: "strict", secure: true };
            Cookies.remove(cookieName, neededAttributes);
          });
        };
      }

      return API.deleteSession(sessionID).then(() => {
        // Update sessions query data"
        queryClient.invalidateQueries({
          queryKey: ["sessions"],
        });

        callFunctionIfExists(onSuccess);
      });
    },
  });

  return {
    deleteSession: deleteSession.mutate,
    sessionDeleting: deleteSession.isPending,
  };
};

export default useDeleteSession;
